import { render } from "./EmoticonFace3.vue?vue&type=template&id=6b1cb764&ts=true"
import script from "./EmoticonFace3.vue?vue&type=script&lang=ts"
export * from "./EmoticonFace3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__